import React from 'react';
import Slider from 'react-slick';
import { Heart, Users, Star, Award, TrendingUp, Sparkles } from 'lucide-react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import one from "../assets/worked/1.png";
import two from "../assets/worked/2.png";
import three from "../assets/worked/3.png";
import four from "../assets/worked/4.png";
import five from "../assets/worked/5.png";
import six from "../assets/worked/6.png";
import seven from "../assets/worked/7.png";
import eight from "../assets/worked/8.png";
import nine from "../assets/worked/9.png";
import ten from "../assets/worked/10.png";
import eleven from "../assets/worked/11.png";
import twelve from "../assets/worked/12.png";
import thirteen from "../assets/worked/13.png";
import fourteen from "../assets/worked/14.png";
import sixteen from "../assets/worked/16.png";
import seventeen from "../assets/worked/17.png";
import eighteen from "../assets/worked/18.png";
import nineteen from "../assets/worked/19.png";
import twenty from "../assets/worked/20.png";
import twentyOne from "../assets/worked/21.png";
import twentyTwo from "../assets/worked/22.png";
import twentyThree from "../assets/worked/23.png";
import twentyFour from "../assets/worked/24.png";
import twentyFive from "../assets/worked/25.png";
import twentySix from "../assets/worked/26.png";
import twentySeven from "../assets/worked/27.png";
import twentyEight from "../assets/worked/28.png";
import twentyNine from "../assets/worked/29.png";
import thirty from "../assets/worked/30.png";
import thirtyOne from "../assets/worked/31.png";
import thirtyTwo from "../assets/worked/32.png";
import thirtyThree from "../assets/worked/33.png";
import thirtyFour from "../assets/worked/34.png";
import thirtyFive from "../assets/worked/35.png";
import thirtySix from "../assets/worked/36.png";
import thirtySeven from "../assets/worked/37.png";
import thirtyEight from "../assets/worked/38.png";
import thirtyNine from "../assets/worked/39.png";
import forty from "../assets/worked/40.png";
import fortyOne from "../assets/worked/41.png";

function ClientsSection() {
    const clients = [
        { image: one, name: "Client 1" },
        { image: two, name: "Client 2" },
        { image: three, name: "Client 3" },
        { image: four, name: "Client 4" },
        { image: five, name: "Client 5" },
        { image: six, name: "Client 6" },
        { image: seven, name: "Client 7" },
        { image: eight, name: "Client 8" },
        { image: nine, name: "Client 9" },
        { image: ten, name: "Client 10" },
        { image: eleven, name: "Client 11" },
        { image: twelve, name: "Client 12" },
        { image: thirteen, name: "Client 13" },
        { image: fourteen, name: "Client 14" },
        { image: sixteen, name: "Client 16" },
        { image: seventeen, name: "Client 17" },
        { image: eighteen, name: "Client 18" },
        { image: nineteen, name: "Client 19" },
        { image: twenty, name: "Client 20" },
        { image: twentyOne, name: "Client 21" },
        { image: twentyTwo, name: "Client 22" },
        { image: twentyThree, name: "Client 23" },
        { image: twentyFour, name: "Client 24" },
        { image: twentyFive, name: "Client 25" },
        { image: twentySix, name: "Client 26" },
        { image: twentySeven, name: "Client 27" },
        { image: twentyEight, name: "Client 28" },
        { image: twentyNine, name: "Client 29" },
        { image: thirty, name: "Client 30" },
        { image: thirtyOne, name: "Client 31" },
        { image: thirtyTwo, name: "Client 32" },
        { image: thirtyThree, name: "Client 33" },
        { image: thirtyFour, name: "Client 34" },
        { image: thirtyFive, name: "Client 35" },
        { image: thirtySix, name: "Client 36" },
        { image: thirtySeven, name: "Client 37" },
        { image: thirtyEight, name: "Client 38" },
        { image: thirtyNine, name: "Client 39" },
        { image: forty, name: "Client 40" },
        { image: fortyOne, name: "Client 41" },
    ];

    // 2 rows ke liye settings
    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 5,
        slidesToScroll: 5,
        rows: 2,
        slidesPerRow: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true,
        arrows: true,
        dotsClass: "slick-dots custom-dots",
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    rows: 2,
                    arrows: false,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    rows: 2,
                    arrows: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    rows: 2,
                    arrows: false,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 2,
                    arrows: false,
                },
            },
        ],
    };

    const stats = [
        {
            icon: <Users className="w-6 h-6" />,
            value: "50+",
            label: "Satisfied Clients",
            color: "from-blue-500 to-cyan-500",
            bgColor: "from-blue-50 to-cyan-50",
            iconBg: "from-blue-500 to-cyan-500",
            suffix: "",
            description: "Trusted partners worldwide"
        },
        {
            icon: <Star className="w-6 h-6" />,
            value: "98%",
            label: "Client Retention",
            color: "from-purple-500 to-pink-500",
            bgColor: "from-purple-50 to-pink-50",
            iconBg: "from-purple-500 to-pink-500",
            suffix: "",
            description: "Long-term relationships"
        },
        {
            icon: <Award className="w-6 h-6" />,
            value: "100%",
            label: "Project Success",
            color: "from-amber-500 to-orange-500",
            bgColor: "from-amber-50 to-orange-50",
            iconBg: "from-amber-500 to-orange-500",
            suffix: "",
            description: "On-time delivery guaranteed"
        },
        {
            icon: <TrendingUp className="w-6 h-6" />,
            value: "150+",
            label: "Projects Completed",
            color: "from-emerald-500 to-green-500",
            bgColor: "from-emerald-50 to-green-50",
            iconBg: "from-emerald-500 to-green-500",
            suffix: "",
            description: "Across various industries"
        }
    ];

    return (
        <div className="relative bg-gradient-to-br from-slate-50 via-white to-emerald-50 py-20 md:py-28 overflow-hidden">
            {/* Animated Background Elements */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute -top-40 -right-40 w-80 h-80 bg-emerald-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
                <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
            </div>

            {/* Floating Elements */}
            <div className="absolute top-20 left-10 opacity-20 hidden lg:block">
                <Sparkles className="w-8 h-8 text-emerald-400 animate-pulse" />
            </div>
            <div className="absolute bottom-20 right-10 opacity-20 hidden lg:block">
                <Sparkles className="w-12 h-12 text-blue-400 animate-pulse animation-delay-2000" />
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                {/* Header Section */}
                <div className="text-center max-w-4xl mx-auto mb-16">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-emerald-100 via-green-100 to-emerald-100 rounded-full mb-6 shadow-sm">
                        <Heart className="w-4 h-4 text-emerald-600 fill-current" />
                        <span className="text-sm font-semibold text-emerald-700 tracking-wide">
                            TRUSTED BY INDUSTRY LEADERS
                        </span>
                        <Heart className="w-4 h-4 text-emerald-600 fill-current" />
                    </div>

                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
                        <span className="bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
                            We've Worked With
                        </span>
                        <br />
                        <span className="bg-gradient-to-r from-emerald-600 via-green-600 to-emerald-600 bg-clip-text text-transparent">
                            Amazing Brands
                        </span>
                    </h2>

                    <div className="flex items-center justify-center gap-3 text-emerald-700 bg-emerald-50/50 backdrop-blur-sm px-6 py-3 rounded-full max-w-md mx-auto">
                        <Heart size={20} className="fill-emerald-500 animate-pulse" />
                        <p className="text-gray-700 font-medium">Our main treasure is our happy and satisfied clients</p>
                        <Heart size={20} className="fill-emerald-500 animate-pulse" />
                    </div>
                </div>

                {/* 2-Row Clients Carousel */}
                <div className="mb-20 relative">
                    <div className="absolute -inset-4 bg-gradient-to-r from-emerald-200/20 via-transparent to-green-200/20 rounded-3xl blur-3xl"></div>

                    <div className="relative">
                        <Slider {...settings}>
                            {clients.map((client, index) => (
                                <div key={index} className="px-2">
                                    <div className="group relative bg-white rounded-2xl border border-gray-100 
                                                    hover:border-emerald-200 hover:shadow-2xl hover:shadow-emerald-100/50
                                                    transition-all duration-500 
                                                    h-[140px] md:h-[160px] 
                                                    flex items-center justify-center
                                                    transform hover:-translate-y-2
                                                    cursor-pointer
                                                    overflow-hidden
                                                    my-3">

                                        {/* Hover Effect Overlay */}
                                        <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/0 via-green-500/0 to-emerald-500/0 
                                                        group-hover:from-emerald-500/5 group-hover:via-green-500/5 group-hover:to-emerald-500/5 
                                                        transition-all duration-500"></div>

                                        {/* Shine Effect */}
                                        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700">
                                            <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent via-white/60 to-transparent group-hover:animate-shine"></div>
                                        </div>

                                        <img
                                            src={client.image}
                                            alt={`Client ${index + 1}`}
                                            className="max-h-[70px] md:max-h-[90px] w-auto px-3
                                                      
                                                       transition-all duration-500 
                                                       scale-90 group-hover:scale-110
                                                       relative z-10"
                                        />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>

                {/* Stats Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {stats.map((stat, index) => (
                        <div
                            key={index}
                            className="group relative bg-white rounded-2xl p-6
                                     border border-gray-100
                                     hover:border-transparent
                                     hover:shadow-2xl
                                     transition-all duration-500
                                     transform hover:-translate-y-2
                                     overflow-hidden"
                        >
                            {/* Gradient Background on Hover */}
                            <div className={`absolute inset-0 bg-gradient-to-br ${stat.bgColor} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>

                            {/* Content */}
                            <div className="relative z-10">
                                <div className={`inline-flex p-3 bg-gradient-to-r ${stat.iconBg} rounded-xl shadow-lg mb-4
                                                transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-500`}>
                                    <div className="text-white">
                                        {stat.icon}
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <div className="flex items-baseline gap-1">
                                        <span className={`text-3xl md:text-4xl font-bold bg-gradient-to-r ${stat.color} bg-clip-text text-transparent`}>
                                            {stat.value}
                                        </span>
                                        {stat.suffix && (
                                            <span className="text-xl font-bold text-gray-400">{stat.suffix}</span>
                                        )}
                                    </div>

                                    <h3 className="text-lg font-semibold text-gray-800">
                                        {stat.label}
                                    </h3>

                                    <p className="text-sm text-gray-500">
                                        {stat.description}
                                    </p>
                                </div>
                            </div>

                            {/* Decorative Elements */}
                            <div className="absolute bottom-0 right-0 w-24 h-24 bg-gradient-to-br from-white/50 to-transparent rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                    ))}
                </div>
            </div>

            <style jsx>{`
                @keyframes blob {
                    0% { transform: translate(0px, 0px) scale(1); }
                    33% { transform: translate(30px, -50px) scale(1.1); }
                    66% { transform: translate(-20px, 20px) scale(0.9); }
                    100% { transform: translate(0px, 0px) scale(1); }
                }
                
                .animate-blob {
                    animation: blob 7s infinite;
                }
                
                .animation-delay-2000 {
                    animation-delay: 2s;
                }
                
                .animation-delay-4000 {
                    animation-delay: 4s;
                }

                @keyframes shine {
                    100% { left: 200%; }
                }

                .animate-shine {
                    animation: shine 1.5s;
                }

                :global(.slick-dots.custom-dots) {
                    bottom: -40px;
                }

                :global(.slick-dots.custom-dots li button:before) {
                    font-size: 12px;
                    color: #10b981;
                    opacity: 0.3;
                    transition: all 0.3s;
                }

                :global(.slick-dots.custom-dots li.slick-active button:before) {
                    opacity: 1;
                    color: #10b981;
                    transform: scale(1.2);
                }

                :global(.slick-prev:before, .slick-next:before) {
                    color: #10b981;
                    font-size: 24px;
                    opacity: 0.5;
                    transition: opacity 0.3s;
                }

                :global(.slick-prev:hover:before, .slick-next:hover:before) {
                    opacity: 1;
                }

                :global(.slick-prev) {
                    left: -30px;
                }

                :global(.slick-next) {
                    right: -30px;
                }

                /* 2 rows ke liye spacing */
                :global(.slick-slide > div) {
                    margin: 8px 0;
                }
            `}</style>
        </div>
    );
}

export default ClientsSection;